<script>
    import { createEventDispatcher } from 'svelte';

    import user from '../../state/user';

    const dispatch = createEventDispatcher();

    export let email;

    let signInForm = {
        email,
        pass: ''
    };

    if (email && email.length) {
        checkUser();
    }

    let signInSubmitting = false;
    let signInError = '';
    let showPasswordField = true;
    let clnId = null;

    async function onSignIn() {
        signInSubmitting = true;
        signInError = '';
        let result = await user.signIn(signInForm.email, signInForm.pass);
        signInSubmitting = false;

        if (result) {
            dispatch('close');
        } else {
            signInError = 'Přihlášení se nezdařilo!';
        }
    }

    async function checkUser(e) {
        let result = await user.getByEmail(signInForm.email);

        if (!result) {
            showPasswordField = true;
            clnId = null;
            return;
        }

        showPasswordField = result.hasPassword;
        clnId = parseInt(result.cln_id);
        //clnId = !result.hasPassword ? parseInt(result.cln_id) : null;
    }

    async function setupPassword(e) {
        signInSubmitting = true;
        signInError = '';
        let result = await user.setupPassword(clnId);
        signInSubmitting = false;

        if (result) {
            alert('Email byl odeslán, postupujte podle informací v něm.');
            dispatch('close');
        } else {
            signInError = 'Odeslání emailu se nezdařilo!';
        }
    }
</script>

<style>
    .controls {
        position: absolute;
        bottom: 20px;
        z-index: 1;
    }
</style>

<form on:submit|preventDefault={onSignIn}>
    {#if signInError}
        <article class="message is-danger">
            <div class="message-body">{signInError}</div>
        </article>
    {/if}

    <div class="field">
        <label class="label" for="signInEmail">Email</label>
        <div class="control">
            <input  class="input" id="signInEmail" type="email"
                    bind:value={signInForm.email}
                    on:change={checkUser}
                    placeholder="vas@email.cz" required>
        </div>
    </div>

    {#if showPasswordField}
        <div class="field">
            <label class="label" for="signInPassword">Heslo</label>
            <div class="control">
                <input class="input" id="signInPassword" type="password"
                    bind:value={signInForm.pass}
                    placeholder="Vaše heslo" required>
            </div>
        </div>
    {:else}
        <div class="notification is-info">
            Na tento email účet existuje, ale není pro něj zvoleno heslo.<br>
            Chcete jej vytvořit ? Bude vám odeslán email s odkazem na tvorbu hesla.
        </div>
    {/if}

    <div class="controls">
        <div class="buttons">
            {#if showPasswordField}
                <button class="button is-success" class:is-loading={signInSubmitting}>Přihlásit</button>

                <button type="button" class="button is-success btn-x"
                        on:click={setupPassword}
                        class:is-loading={signInSubmitting}
                        disabled={!clnId}>Zapomněl(a) jsem heslo</button>
            {:else}
                <button type="button" class="button is-success" on:click={setupPassword}>Odeslat email</button>
            {/if}

            <button type="button" class="button"
                    class:is-loading={signInSubmitting}
                    on:click|preventDefault={() => dispatch('close')}>
                Zrušit
            </button>
        </div>
    </div>
</form>